import { Route, Routes } from 'react-router-dom';
import StreamContainer from '../containers/stream/StreamContainer';
import MultiDeviceStreamContainer from '../containers/stream/MultiDeviceStreamContainer';

export const Router = () => (
  <Routes>
    <Route path="/overlay" element={<StreamContainer />} />
    <Route
      path="/multi-device-overlay"
      element={<MultiDeviceStreamContainer />}
    />
  </Routes>
);
